export const getFilteredArray = (data, exclude) => {
  if (exclude) return data.filter((data) => !exclude.includes(data.slug));
  return data;
};
